import React from 'react';

const ComingSoon: React.FC = () => {
    return <p>
        (COMING SOONG)
    </p>;
};

export default ComingSoon;
